// extracted by mini-css-extract-plugin
export default {"card":"styles_card__cU1ok","text_hlight":"styles_text_hlight__2J9lK","carousel_wrapper":"styles_carousel_wrapper__+0eKN"};